import styled from 'styled-components';

export const LabelWrapper = styled.div`
  color: var(--colors-grays-black, #000);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const FieldWrapper = styled.div`
  color: var(--colors-grays-black, #000);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 23px;
`;
